import { HttpInterceptorFn, HttpXsrfTokenExtractor } from '@angular/common/http';
import { inject } from '@angular/core';

export const csrfInterceptor: HttpInterceptorFn = (request, next) => {
  const tokenService = inject(HttpXsrfTokenExtractor);

  if ( request.method === 'HEAD') {
    return next(request);
  }

  const token = tokenService.getToken();

  // Be careful not to overwrite an existing header of the same name.
  if (token !== null && !request.headers.has('X-XSRF-TOKEN')) {
    request = request.clone({headers: request.headers.set('X-XSRF-TOKEN', token)});
  } else {
    console.log('NO SE AGREGO TOKEN AL REQUEST');
    console.log(token);
  }
  return next(request);
};
